import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider, CssBaseline } from "@material-ui/core";
import {
    GRPC_PLACES_PORT,
    GRPC_REMOTE_MONITOR_PORT,
    GRPC_RESERVATION_PORT,
    GRPC_SITE_PORT,
    GRPC_STATION_PORT,
    GRPC_URL,
    GRPC_USER_PORT,
} from "@optimusride/client-library/constants";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { Global, css } from "@emotion/react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import Routes from "./features/Routes";
import theme from "./features/Theme";
import { store } from "./store";
import "./i18n";
import ErrorPage from "./features/ErrorPage";

dayjs.extend(utc);
dayjs.extend(timezone);

/* The ENV variable is defined in the scripts section of package json. Example ENV=PROD */
const ENV = "__ENV__" as string;

if (ENV === "PROD") {
    Sentry.init({
        dsn: "https://599eea2df6cd440b80e8d0e74313265f@o851383.ingest.sentry.io/5818304",
        integrations: [new Integrations.BrowserTracing({
            tracingOrigins: [
                `^${GRPC_URL}:${GRPC_USER_PORT}`,
                `^${GRPC_URL}:${GRPC_REMOTE_MONITOR_PORT}`,
                `^${GRPC_URL}:${GRPC_SITE_PORT}`,
                `^${GRPC_URL}:${GRPC_RESERVATION_PORT}`,
                `^${GRPC_URL}:${GRPC_STATION_PORT}`,
                `^${GRPC_URL}:${GRPC_PLACES_PORT}`,
            ],
        })],
        environment: ENV,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.80,
    });
}

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Global styles={css`
                html, body, #root {
                    height: 100%;
                }
            `}
            />
            <Sentry.ErrorBoundary fallback={ErrorPage}>
                <Provider store={store}>
                    <Router>
                        <Routes />
                    </Router>
                </Provider>
            </Sentry.ErrorBoundary>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById("root"),
);
